module.exports = __webpack_public_path__ + "hindi-vertical-banner-4732db87a68c4ecda392.png";